export class Option {
    public static readonly default = {
        id: -1,
        name: 'Pilih',
        code: 'Pilih',
    };
}